import { ArrowRight } from 'lucide-react';
import type { NewsfeedArticleDto } from '@sportspredict/shared';
import { openUrlInDefaultBrowser } from '@/utils';

interface NewsfeedArticleCardProps {
	article: NewsfeedArticleDto;
}

export function NewsfeedArticleCard({ article }: NewsfeedArticleCardProps) {
	const imageSrc = article.img_variants?.m || article.img_variants?.l;

	return (
		<div className="flex h-full flex-col overflow-hidden rounded-2xl font-['DM_Sans']">
			<div
				className="h-32 w-full bg-cover bg-center"
				style={{
					backgroundImage:
						'linear-gradient(to bottom, rgba(221,220,220,0.2), rgba(183,104,78,0.2))',
				}}
			>
				{imageSrc && (
					<img src={imageSrc} alt="" className="h-full w-full object-cover mix-blend-multiply" />
				)}
			</div>

			<div className="flex flex-1 flex-col gap-2 rounded-b-2xl border-[0.5px] border-[#DCE3F9] bg-white p-4">
				<span className="w-fit  border-[0.5px] border-[#ACC0F6] bg-[#DCE3F9] px-2 py-0.5 text-[10px] font-semibold uppercase tracking-[0.4px] text-[#5583F6] rounded-[4px] ">
					{article.tag}
				</span>

				<h3 className="text-base font-semibold leading-[20px] text-[#0A0A0A]">{article.header}</h3>

				<p className="text-sm leading-5 text-[#474747]">{article.description}</p>

				<button
					type="button"
					onClick={() => openUrlInDefaultBrowser(article.cta_link)}
					className="mt-auto flex w-full items-center justify-center gap-1.5 rounded-full border-[0.5px] border-[#5583F6] px-4 py-2 text-sm font-semibold text-[#5583F6] transition-colors hover:bg-[#F7F8FC]"
				>
					{article.cta_label}
					<ArrowRight className="size-4" />
				</button>
			</div>
		</div>
	);
}
